import React, { Component } from "react";

export default class InputField extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  render() {
    const {
      placeholder,
      label,
      autoFocus,
      type,
      name,
      value,
      disable,
      require,
      onChange,
      onKeyPress,
      fpgerror,
      id,
      tabindex,
      pattern,
      onBlur,
      prefix=false,
      prefixWidth = "https://www.",
      maxLength,
    } = this.props;
    return (
      <div className="field_row_inner">
        {label ? <label className={`${require ? "required" : null}`}>{label} </label> : ""}
        <div className="field_input relative">
          {/* {

                        name === 'tileUrl' ? <input 
                        type={type} 
                        name={name} 
                        value={value} 
                        placeholder={placeholder} 
                        disabled={disable}
                        onChange={(e) => this.props.onChange(e, id)}
                        onBlur={(e)=>this.props && this.props.onBlur(e)}
                    /> 
                    :  */}
          {prefix && <span className="sd_input_prefix">{prefixWidth}</span>}
          <input
            autoFocus={autoFocus}
            type={type}
            name={name}
            value={value}
            placeholder={placeholder}
            disabled={disable}
            id={id}
            autoComplete="off"
            onKeyPress={onKeyPress ? onKeyPress : () => {}}
            onChange={e => onChange(e, id)}
            tabindex={tabindex}
            pattern={pattern}
            onBlur={onBlur}
            maxLength={maxLength}
          />
          {/* } */}

          {fpgerror ? <span className="error">{fpgerror}</span> : ""}
        </div>
      </div>
    );
  }
}
